module.exports = __webpack_public_path__ + "static/406161c0-2282-4347-9a29-7e25a195ab1b-b65c20f3c257f9d5fe68b287db55c570.webp";